import {AssetSolarWithdrawalOptionPostDataTransferObject} from "../../data-transfer-object/asset/AssetSolarWithdrawalOptionPostDataTransferObject"

/**
 * 솔라 인출 옵션 속성 설명
 */
export const AssetSolarWithdrawalOptionPostDataTransferObjectDescription: Record<keyof AssetSolarWithdrawalOptionPostDataTransferObject, string> = {
    solarAmount: '차감 솔라',
    cashAmount: '지급 금액'
}
